/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Leave_Empty_Until_CheckoutInputs */

const en_orders_leave_empty_until_checkout = /** @type {(inputs: Orders_Leave_Empty_Until_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave empty until the driver checks out.`)
};

const es_orders_leave_empty_until_checkout = /** @type {(inputs: Orders_Leave_Empty_Until_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejalo vacio hasta que el chofer salga.`)
};

/**
* | output |
* | --- |
* | "Leave empty until the driver checks out." |
*
* @param {Orders_Leave_Empty_Until_CheckoutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_leave_empty_until_checkout = /** @type {((inputs?: Orders_Leave_Empty_Until_CheckoutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Leave_Empty_Until_CheckoutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_leave_empty_until_checkout(inputs)
	return es_orders_leave_empty_until_checkout(inputs)
});